const VariableCategoryColorMap = {
    "Secondary Attribute": "#4682B4",
    "KPI (OO)": "#FF69B4",
    "Agreement KPI": "#008000",
};

export default VariableCategoryColorMap;
